import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";


// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget";
import PageTitle from "../../Components/PageTitle";



import WebsiteAnalyser from "../../Components/WebsiteAnalyser/WebsiteAnalyser";
import PornCheck from "../../Components/PornCheck/PornCheck";
import PiracyPornAnalyser from "../../Components/PiracyPornAnalyser/PiracyPornAnalyser";
const mainChartData = getMainChartData();
const PieChartData = [
  { name: "Group A", value: 400, color: "primary" },
  { name: "Group B", value: 300, color: "secondary" },
  { name: "Group C", value: 300, color: "warning" },
  { name: "Group D", value: 200, color: "success" },
];

export default function Dashboard(props) {
  var classes = useStyles();
  var theme = useTheme();

  // local
  var [mainChartState, setMainChartState] = useState("monthly");

  return (
    <>
    
      <PageTitle title="Website Analyser" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          
          <Widget
            title=""
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
            <WebsiteAnalyser></WebsiteAnalyser>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      <PageTitle title="Porn/Piracy Check" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          
          <Widget
            title=""
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
            <PornCheck></PornCheck>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
      <PageTitle title="Piracy / Porn Analyser" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          
          <Widget
            title=""
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
            <PiracyPornAnalyser></PiracyPornAnalyser>
          </Widget>
          
        </Grid>
        
        
        
       
      </Grid>
    </>
  );
}

// #######################################################################
function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
  var array = new Array(length).fill();
  let lastValue;

  return array.map((item, index) => {
    let randomValue = Math.floor(Math.random() * multiplier + 1);

    while (
      randomValue <= min ||
      randomValue >= max ||
      (lastValue && randomValue - lastValue > maxDiff)
    ) {
      randomValue = Math.floor(Math.random() * multiplier + 1);
    }

    lastValue = randomValue;

    return { value: randomValue };
  });
}

function getMainChartData() {
  var resultArray = [];
  var tablet = getRandomData(31, 3500, 6500, 7500, 1000);
  var desktop = getRandomData(31, 1500, 7500, 7500, 1500);
  var mobile = getRandomData(31, 1500, 7500, 7500, 1500);

  for (let i = 0; i < tablet.length; i++) {
    resultArray.push({
      tablet: tablet[i].value,
      desktop: desktop[i].value,
      mobile: mobile[i].value,
    });
  }

  return resultArray;
}
